import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import { localStorageMiddleware } from "../src/components/helpers/localStorageMiddleware";
import setupInterceptors  from "./services/setupInterceptors";

import loaderReducer from "./slices/loader";
import authReducer from "./slices/authSlice";
import bannerReducer from "./slices/banners";
import pPropertiesReducer from "./slices/pProperties";
import shopReducer from "./slices/shop";
import navigationReducer from "./slices/navigation";
import productReducer from "./slices/product";
import cartReducer from "./slices/cart";
import userAddressReducer from "./slices/address";
import userReducer from "./slices/users";
import orderReducer from "./slices/orders";
import searchReducer from "./slices/search";
import wishlistReducer from "./slices/wishlist";
import reviewReducer from "./slices/reviews";
const persistConfig = {
  key: "root",
  storage: storage,
  stateReconciler: autoMergeLevel2,
  whitelist: ["auth", "cart"],
};

const reducer = combineReducers({
  loader: loaderReducer,
  auth: authReducer,
  banners: bannerReducer,
  pProperties: pPropertiesReducer,
  shop: shopReducer,
  navigation: navigationReducer,
  product: productReducer,
  cart: cartReducer,
  userAddress: userAddressReducer,
  user: userReducer,
  orders: orderReducer,
  search: searchReducer,
  wishlist: wishlistReducer,
  reviews: reviewReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(localStorageMiddleware),
});
setupInterceptors(store);
export const persistor = persistStore(store);
